import React, { useState, useEffect } from "react";
import { Button } from "bootstrap-4-react/lib/components";
import { useDispatch, useSelector } from "react-redux";
import LoaderSpinner from "../../common/Loader";
import { BulkUploadDialog } from "../../common/bulkUploadDialog";
import { getBulkReturnList } from "../../../store/actions/inventory.action";
import DataTable from "../../common/DataTable";
import BatchPagination from "../../batch/BatchPagination";
import { numOfPage, ReturnBulkCardColumns } from "../../../constant";

const ReturnBulkUpload = (props) => {
  const [loader, setLoader] = useState(false);
  const [uploadShow, setUploadShow] = useState(false);
  const returnBulkUploadList = useSelector((state) => state?.InventoryManagement?.bulkReturnList);
  const returnBulkUploadListStatus = useSelector((state) => state?.InventoryManagement?.bulkReturnListStatus);
  const dispatch = useDispatch();

  let dataLoad = {
    pageIndex: 1,
    pageSize: 30,
    sortColumn: "",
    sortOrder: "DESCENDING",
    searchkey: "",
    employeeId: 0,
    companyId: 0,
    sellerId: 0,
    createdBy: 0,
    createdDate: "2025-04-28T23:04:51.097Z",
    isActive: true,
    modifiedBy: 0,
    modifiedDate: "2025-04-28T23:04:51.097Z",
    companySellerId: 0,
    role: 0,
    isSuperAdmin: true,
    tenantId: 0,
  }

  const [filterValue, setFilterValue] = useState(dataLoad);

  const handleuploadintegration = () => {
    setUploadShow(true);
  }

  useEffect(() => {
    if (!_.isEmpty(filterValue)) {
      fetchReturnUploadList();
    }
  }, [filterValue.pageSize, filterValue.pageIndex, filterValue.sortColumn, filterValue.sortOrder]);


  const fetchReturnUploadList = () => {
    dispatch(getBulkReturnList(filterValue));
  }
  useEffect(() => {
    if (returnBulkUploadList?.TotalRecords) {
      setFilterValue({ ...filterValue, totalRecords: returnBulkUploadList?.TotalRecords, totalPages: Math.ceil(returnBulkUploadList?.TotalRecords / filterValue.pageSize) });
    }
  }, [returnBulkUploadList]);

  useEffect(() => {
    if (returnBulkUploadListStatus === "PENDING") {
      setLoader(true);
    } else {
      setLoader(false);
    }
  }, [returnBulkUploadListStatus]);

  const handleSortingColumn = (key) => {
    let newSortOrder = filterValue.sortOrder === "ASCENDING" ? "DESCENDING" : "ASCENDING";
    setFilterValue({
      ...filterValue,
      sortColumn: key,
      sortOrder: newSortOrder,
    });
  }

  return (
    <main>
      <div className="main__container">
        <div className="main__tile_heading cus-btn-include-sec">
          <div>
            {"Bulk Upload Reports"}
          </div>
          <div className="top_right_button_container">
            <Button
              className="cus-seconday-bg-btn top-btn m2"
              onClick={() => handleuploadintegration()}
            >
              Upload
            </Button>

          </div>
        </div>
        {uploadShow && (
          <BulkUploadDialog
            onHide={() => setUploadShow(false)}
            show={uploadShow}
            hideIntegration={true}
            fetchProductList={fetchReturnUploadList}
            type={3}
          />
        )}
        {loader && <LoaderSpinner />}
        <div className="main_content cus-page-content-sec">
          <div className="main_content_table_history">
            <div className="tableFixHead incomingTbl">
              <DataTable
                loader={loader}
                headers={ReturnBulkCardColumns}
                tableData={returnBulkUploadList?.listCsvFileMaster}
                handleSortingColumn={handleSortingColumn}
                tableDataStatus={returnBulkUploadListStatus}
                filterData={filterValue}
              />
            </div>
          </div>
        </div>
        <BatchPagination
          gridData={returnBulkUploadList?.listCsvFileMaster}
          totalVisualRecords={returnBulkUploadList?.listCsvFileMaster?.length}
          numberOfPage={filterValue.pageSize}
          numOfPage={numOfPage}
          loader={loader}
          currentPage={filterValue.pageIndex}
          totalPages={filterValue.totalPages}
          totalRecords={returnBulkUploadList?.TotalRecords}
          setCurrentPage={(value) => setFilterValue({ ...filterValue, pageIndex: value })}
          setNumberOfPage={(value) => setFilterValue({ ...filterValue, pageSize: value })}
        />
      </div>
    </main>
  );
};

export default ReturnBulkUpload;